export const ShopperSelectPages = {
  GetStarted: 'get-started',
  SelectShopper: 'select-shopper',
  ConfirmShopper: 'confirm-shopper',
};
